import { render, staticRenderFns } from "./openInquiry.vue?vue&type=template&id=1742ee20&scoped=true"
import script from "./openInquiry.vue?vue&type=script&lang=js"
export * from "./openInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1742ee20",
  null
  
)

export default component.exports